import useApiMutation from './useApiMutation';

function useInviteUserMutation(options) {
  return useApiMutation('post', `/v1/invite`, options);
}

export default useInviteUserMutation;
